import fetchHandler from "../../utils/fetchHandler";
import { RECIPES } from "../types/actions";

export const getRecipes = (queryString) => {
	const fetchOptions = {
		url: `/api/recipes?${queryString}`,
		method: "GET",
		actionType: RECIPES.GET_RECIPES
	};
	return fetchHandler(fetchOptions);
};

export const getMyFavourites = () => {
	const fetchOptions = {
		url: `/api/recipes/favorited/`,
		method: "GET",
		actionType: RECIPES.GET_RECIPES_FAVORITED
	};
	return fetchHandler(fetchOptions);
};

export const deleteRecipe = (id, successHandler) => {
	const fetchOptions = {
		url: `/api/recipes/${id}`,
		method: "DELETE",
		actionType: RECIPES.DELETE_RECIPE
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const declineRecipe = (values, successHandler, errorHandler) => {
	const fetchOptions = {
		url: `/api/recipes/${values.id}/decline`,
		method: "POST",
		actionType: RECIPES.DECLINE_RECIPE
	};
	return fetchHandler(fetchOptions, successHandler, errorHandler);
};

export const getRecentRecipes = () => {
	const fetchOptions = {
		url: `/api/recipes/recent_views`,
		method: "GET",
		actionType: RECIPES.GET_RECENT_RECIPES
	};
	return fetchHandler(fetchOptions);
};

export const getRecipeComments = (recipeId) => {
	const fetchOptions = {
		url: `/api/comments/?recipe=${recipeId}&approved=True`,
		method: "GET",
		actionType: RECIPES.GET_RECIPE_COMMENTS
	};
	return fetchHandler(fetchOptions);
};

export const searchRecipes = (queryString) => {
	const fetchOptions = {
		url: `/api/recipes?${queryString}`,
		method: "GET",
		actionType: RECIPES.SEARCH_RECIPES
	};
	return fetchHandler(fetchOptions);
};

export const getAvailableFilters = () => {
	const fetchOptions = {
		url: "/api/recipe_filters",
		method: "GET",
		actionType: RECIPES.GET_AVAILABLE_FILTERS
	};
	return fetchHandler(fetchOptions);
};

export const resetRecipes = () => ({
	type: RECIPES.RESET_RECIPES
});

export const getRecipeDetails = (id, successHandler) => {
	const fetchOptions = {
		url: `/api/recipes/${id}/`,
		method: "GET",
		actionType: RECIPES.RECIPE_DETAILS
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const getRelatedRecipes = (id) => {
	const fetchOptions = {
		url: `/api/recipes/${id}/related_recipes`,
		method: "GET",
		actionType: RECIPES.RELATED_RECIPES
	};
	return fetchHandler(fetchOptions);
};

export const getRecipeNutritionFacts = (id) => {
	const fetchOptions = {
		url: `/api/recipenut_list/?recipe_id=${id}`,
		method: "GET",
		actionType: RECIPES.RECIPE_NUTRITION_FACTS
	};
	return fetchHandler(fetchOptions);
};

export const getRecipeIngredients = (id, val) => {
	const fetchOptions = {
		url: `/api/recipes/${id}/servings/?scale=${val}`,
		method: "GET",
		actionType: RECIPES.RECIPE_INGREDIENTS
	};
	return fetchHandler(fetchOptions);
};

export const addRecipeComment = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/comments/`,
		method: "POST",
		actionType: RECIPES.ADD_RECIPE_COMMENT,
		body: JSON.stringify(values)
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const getFeaturedRecipes = () => {
	const fetchOptions = {
		url: `/api/recipes/featured_recipes`,
		method: "GET",
		actionType: RECIPES.GET_FEATURED_RECIPES
	};
	return fetchHandler(fetchOptions);
};

export const getRecipeCommentsNotApproved = (queryString = null) => {
	const fetchOptions = {
		url: `/api/comments/?${queryString}`,
		method: "GET",
		actionType: RECIPES.GET_RECIPE_COMMENTS_APPROVAL
	};
	return fetchHandler(fetchOptions);
};

export const approveRecipeComment = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/comments/${values.id}/admin_approval`,
		method: "PUT",
		actionType: RECIPES.APPROVE_RECIPE_COMMENT,
		body: JSON.stringify(values)
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const declineRecipeComment = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/comments/${values.id}/admin_approval`,
		method: "PUT",
		actionType: RECIPES.APPROVE_RECIPE_COMMENT,
		body: JSON.stringify(values)
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const isfavouriteRecipe = (id, successHandler) => {
	const fetchOptions = {
		url: `/api/recipes/${id}/is_favorited`,
		method: "GET",
		actionType: RECIPES.RECIPE_IS_FAVOURITE
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const favouriteRecipe = (id, successHandler) => {
	const fetchOptions = {
		url: `/api/recipe_favorites/`,
		method: "POST",
		actionType: RECIPES.RECIPE_SET_FAVOURITE,
		body: JSON.stringify({ recipe: id })
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const unFavouriteRecipe = (id, successHandler) => {
	const fetchOptions = {
		url: `/api/recipe_favorites/${id}/`,
		method: "DELETE",
		actionType: RECIPES.RECIPE_SET_FAVOURITE
	};
	return fetchHandler(fetchOptions, successHandler);
};
